/**
 * Xóa toàn bộ localStorage khi đang ở route /auth/install.
 * Dùng từ bootstrap (trước React) và useLayoutEffect MyApp (trước useEffect ghi storage).
 */
export function clearLocalStorageOnInstallRoute(): void {
  if (typeof window === 'undefined') return
  if (window.location.pathname !== '/auth/install') return
  try {
    localStorage.clear()
  } catch {
    // ignore (private mode, quota, …)
  }
}
